import React from "react";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

import { NotificationProps, NotificationVariant } from "./types";
import "./styles.css";

const Icon: React.FC<{ variant: NotificationVariant }> = ({ variant }) => {
  switch (variant) {
    case "success":
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1 14-4-4 1.4-1.4L11 12.2l5.6-5.6L18 8l-7 8Z"
          />
        </svg>
      );
    case "danger":
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1 5h2v7h-2V7Zm0 9h2v2h-2v-2Z"
          />
        </svg>
      );
    case "warning":
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M1 21h22L12 2 1 21Zm12-3h-2v-2h2v2Zm0-4h-2v-4h2v4Z"
          />
        </svg>
      );
    case "info":
    default:
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M11 17h2v-6h-2v6Zm0-8h2V7h-2v2Zm1-7a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z"
          />
        </svg>
      );
  }
};

export const Notification: React.FC<NotificationProps> = ({
  show,
  timer = 4000,
  handleClose,
  autohide = false,
  title,
  description,
  subtitle,
  position = "top-center",
  variant = "danger",
}) => {
  const ariaLive = variant === "danger" ? "assertive" : "polite";

  return (
    <ToastContainer
      position={position}
      className="p-3 notification-stack"
      containerPosition="fixed"
    >
      <Toast
        onClose={handleClose}
        show={show}
        delay={timer}
        autohide={autohide}
        className={`notification-toast is-${variant} shadow-lg border-0`}
        role="status"
        aria-live={ariaLive}
        style={{ ["--toast-duration" as any]: `${timer}ms` }}
      >
        <div className="notification-accent" />
        <Toast.Header closeButton={false} className="notification-header">
          <span className="notification-icon">
            <Icon variant={variant} />
          </span>
          <strong className="me-auto">{title}</strong>
          {subtitle && (
            <small className="text-body-secondary ms-2">{subtitle}</small>
          )}
          <button
            type="button"
            className="btn-close btn-close-white ms-3"
            aria-label="Close"
            onClick={handleClose}
          >
            <span aria-hidden>×</span>
          </button>
        </Toast.Header>

        <Toast.Body className="notification-body">
          <p className="notification-description">{description}</p>
          <div className="notification-progress" />
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};
